import React, { useEffect, useState } from 'react';
import { useFetch } from '@gjensidige/gpf-react-components';
import { useParams } from 'react-router-dom';
import { getPaymentInfo } from '../../../utils/api';
import { text } from '../../../utils/text';
import { SpinnerPage } from '../../common/SpinnerPage/SpinnerPage';
import { Layout } from '../../common/Layout/Layout';
import { Card } from '../../common/Card/Card';
import { Text, Title } from '@gjensidige/core-typography';
import { KidAccountCopy } from '../../common/KidAccountCopy/KidAccountCopy';
import { scenarioSteps, trackScenario } from '../../../tracking';
export const AvtaleGiroPage = () => {
    const { kid, status } = useParams();
    const [signedStatus, setSignedStatus] = useState(undefined);
    const [isFetching, paymentInfo] = useFetch({
        promise: () => getPaymentInfo(kid),
        deps: [kid],
    });
    useEffect(() => {
        if (status === 'ok' || status === 'print') {
            trackScenario(scenarioSteps.AVTALEGIRO_SIGNING_COMPLETE);
            setSignedStatus({ signed: true, status: status });
        }
        else {
            setSignedStatus({ signed: false, status: status != undefined ? status.toString() : 'error' });
        }
    }, [status]);
    if (signedStatus === undefined || isFetching) {
        return React.createElement(SpinnerPage, null);
    }
    if (signedStatus && !signedStatus.signed && !isFetching) {
        return (React.createElement(Layout, { title: text.AVTALEGIRO_PAGE.AVTALEGIRO_FAILED.no },
            React.createElement(Card, { title: status === 'cancel'
                    ? text.AVTALEGIRO_PAGE.ERROR_CANCELED.no
                    : text.AVTALEGIRO_PAGE.ERROR_GENERIC_AVTALEGIRO.no, subtitle: text.AVTALEGIRO_PAGE.ERROR_SUBTEXT.no })));
    }
    return (React.createElement(Layout, { title: text.LAYOUT.SIGNED_AVTALEGIRO.TITLE.no }, signedStatus && signedStatus.signed && !isFetching && paymentInfo && (React.createElement(Card, { title: text.AVTALEGIRO_PAGE.CARD_TITLE.no, subtitle: text.AVTALEGIRO_PAGE.CARD_SUBTITLE(paymentInfo.savingsAmount, paymentInfo.expectedTrekkdato).no },
        React.createElement("div", null,
            React.createElement(Title, { tag: 'h3', size: 'h5' }, text.AVTALEGIRO_PAGE.SAVE_MORE.no),
            React.createElement(Text, null, text.AVTALEGIRO_PAGE.SAVE_MORE_SUBTITLE.no)),
        React.createElement(KidAccountCopy, { kid: paymentInfo.kid, accountNumber: paymentInfo.account }),
        React.createElement(Text, null, text.AVTALEGIRO_PAGE.KID_AND_ACCOUNT_NUMBER_INFO.no)))));
};
